import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { useAuth } from "@/contexts/AuthContext";
import { db } from "@/integrations/firebase/firestore";

export const useIsSystemAdmin = () => {
  const { authUser } = useAuth();
  const [isSystemAdmin, setIsSystemAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!authUser) {
      setIsSystemAdmin(false);
      setIsLoading(false);
      return;
    }

    const checkAdmin = async () => {
      try {
        const adminDocRef = doc(db, "admin_users", authUser.uid);
        const adminDoc = await getDoc(adminDocRef);
        setIsSystemAdmin(adminDoc.exists());
      } catch {
        setIsSystemAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdmin();
  }, [authUser]);

  return { isSystemAdmin, isLoading };
};
